import axios from '../axios'
// export const matchId = 12
export const matchId = 1316
/**
 * 项目分类
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const seriesGroup = () => {
  return axios({
    url: `match/webSiteMatchSeries/seriesGroup/${matchId}`,
    method: 'GET',
    headers: {
      isToken: false,
    }
  })
}
/**
 * 项目分类
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const seriesMedal = (data) => {
  data.matchId=matchId
  return axios({
    url: 'match/webSiteMatchSeries/seriesMedal',
    method: 'POST',
    data,
    headers: {
      isToken: false,
    }
  })
}

/**
 * 项目分类
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const seriesMedalRanking = (data) => {
  data.matchId=matchId
  return axios({
    url: 'match/webSiteMatchSeries/seriesMedalRanking',
    method: 'POST',
    data,
    headers: {
      isToken: false,
    }
  })
}
/**
 * 查询该单位该奖牌是哪些项目获奖，对应的数量
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const medalProgramNum = (data) => {
  data.matchId=matchId
  return axios({
    url: 'match/webSiteMatchSeries/medalProgramNum',
    method: 'POST',
    data,
    headers: {
      isToken: false,
    }
  })
}
/**
 * 首页机构榜
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findSeriesRankList = (data) => {
  data.matchId=matchId
  return axios({
    url: 'match/website/findSeriesGroupList',
    method: 'POST',
    data,
    headers: {
      isToken: false
    }
  })
}
/**
 * 选择项目列表
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const seriesProgram = () => {
  // const matchId=992
  return axios({
    url: `match/website/seriesProgram/${matchId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}
/**
 * 选择机构榜
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const seriesAgency = () => {
  // const matchId=992
  return axios({
    url: `match/website/seriesAgency/${matchId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}
/**
 * 赛程
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const scheduleList = () => {
  return axios({
    url: `match/webSiteMatchSeries/scheduleList/${matchId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}
/**
 * 获取运动会信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const querySeriesMatchDetail= () => {
  return axios({
    url: `match/webSiteMatchSeries/querySeriesMatchDetail/${matchId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}
/**
 * 获取赛事列表
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const programMatchList= (matchIds) => {
  return axios({
    url: 'match/webSiteMatchSeries/programMatchList',
    method: 'POST',
    data:matchIds,
    headers: {
      isToken: false
    }
  })
}

/**
 * 查询自己的代表团
 * @returns {Promise | Promise<unknown>}
 */
export const delegationSelfAgency = () => {
  return axios({
    url: `agency/agencyInfo/agencySelf/${matchId}`,
    method: 'GET'
  })
}


/**
 * 代表团注册
 */
export const delegationAddSeriesAgency = data => {
  return axios({
    url: 'match/delegation/addSeriesAgency',
    method: 'POST',
    data
  })
}

/**
 * 查询代表团授权项目人员
 * @param agencyId
 * @returns {Promise<unknown>}
 */
export const delegationTeamJoinGroup = agencyId => {
  return axios({
    url: `match/delegation/list/${agencyId}/${matchId}`,
    method: 'GET'
  })
}

/**
 * 查询子账户授权项目
 * @param agencyId
 * @returns {Promise<unknown>}
 */
export const delegationTeamJoinGroupSub = () => {
  return axios({
    url: `match/delegation/listSelf/${matchId}`,
    method: 'GET'
  })
}

/**
 * 代表团添加授权项目人员
 * @param data
 * @returns {Promise<unknown>}
 */
export const delegationAddUser = data => {
  return axios({
    url: 'match/delegation/add',
    method: 'POST',
    data
  })
}

/**
 * 删除代表团授权项目人员
 * @param id
 * @returns {Promise<unknown>}
 */
export const delegationDelUser = id => {
  return axios({
    url: `match/delegation/delete/${id}`,
    method: 'DELETE'
  })
}

/**
 * 代表团列表
 * @returns {Promise<unknown>}
 */
export const delegationList = () => {
  return axios({
    url: `match/webSiteMatchSeries/delegationList/${matchId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}
/**
 * 代表团详情
 * @returns {Promise<unknown>}
 */
export const delegationDetail = (data) => {
  data.matchId=matchId
  return axios({
    url: '/match/webSiteMatchSeries/delegationDetail',
    method: 'POST',
    data,
    headers: {
      isToken: false
    }
  })
}
/**
 * 奖牌分组
 * @returns {Promise<unknown>}
 */
export const seriesGroupName = () => {
  return axios({
    url: `match/webSiteMatchSeries/seriesGroupName/${matchId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}
/**
 * 奖牌分组
 * @returns {Promise<unknown>}
 */
export const findSportGroupName = (title) => {
  return axios({
    url: `match/webSiteMatchSeries/findSportGroupName/${matchId}` + '/' + title,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 最美城市/精彩锦集
 * @returns {Promise<unknown>}
 */
export const mapdepotList = (data) => {
  data['matchId'] = matchId
  return axios({
    url: 'match/webSiteMatchSeries/mapdepotList',
    method: 'POST',
    data,
    headers: {
      isToken: false
    }
  })
}
/**
 * 代表团运动员详情
 * @returns {Promise<unknown>}
 */
export const seriesPlayerDetail = (data) => {
  return axios({
    url: `/match/webSiteMatchSeries/seriesPlayerDetail/${data.matchId}/${data.agencyId}/${data.playerId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}
/**
 * 获取赛事场馆
 * @returns {Promise | Promise<unknown>}
 */
export const matchFieldList = () => {
  return axios({
    url: `venue/web/matchFieldList/${matchId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}
/**
 * 获取排球赛程
 * @returns {Promise | Promise<unknown>}
 */
export const queryBigballV1 = (data) => {
  // data.matchId=31
  return axios({
    url: '/match/website/queryBigballV1',
    data,
    method: 'POST'
  })
}
/**
 * 获取排球轮次接口
 * @returns {Promise | Promise<unknown>}
 */
export const queryBigballPkRank = (data) => {
  return axios({
    url: '/match/website/queryBigballPkRank',
    data,
    method: 'POST'
  })
}
/**
 * 获取排球球队榜
 * @returns {Promise | Promise<unknown>}
 */
export const footballIntegralRank = (data) => {
  return axios({
    url: `/match/football/footballIntegralRank/${data.matchId}`,
    method: 'GET'
  })
}
/**
 * 获取排球球员榜
 * @returns {Promise | Promise<unknown>}
 */
export const queryBigballPlayer = (data) => {
  return axios({
    url: '/match/website/queryBigballPlayer',
    data,
    method: 'POST'
  })
}

/**
 * 代表团报名
 * @param {*} data
 */
export const joinDelegation = (data) => {
  data.matchId = matchId
  return axios({
    url: '/matchJoin/matchJoin/join/joinDelegation',
    method: 'post',
    data,
  })
}

/**
 * 代表团名单提交
 * @param {*} data
 */
export const joinDelegationName = (data) => {
  data.matchId = matchId
  return axios({
    url: '/matchJoin/matchJoin/join/joinDelegationName',
    method: 'post',
    data,
  })
}

/**
 * 查询联赛、系列赛、运动会赛事详情 {matchId}
 * @param {*} data
 */
export const querySportsProgram = () => {
  return axios({
    url: '/match/webSiteMatchSeries/querySportsProgram/' + matchId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询代表团报名
 * @param {*} data
 */
export const queryDelegation = (data) => {
  return axios({
    url: '/matchJoin/matchJoin/join/queryDelegation/' + matchId + '/' + data.agencyId,
    method: 'get',
  })
}

/**
 * 查询代表团报名
 * @param {*} data
 */
export const queryDelegationName = (data) => {
  return axios({
    url: '/matchJoin/matchJoin/join/queryDelegationName/' + matchId + '/' + data.agencyId,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/comm/http/modules/district.js